<template>
    <div class="wrapper">
        <checkpoint v-if="!$store.state.authentication.checked"></checkpoint>

        <login v-if="$store.state.authentication.checked && !$store.state.authentication.loggedIn "/>

        <template v-if="$store.state.authentication.loggedIn && $store.state.authentication.checked">
            <Header />
            <side-bar>
                <sidebar-link to="/home">
                    <md-icon>home</md-icon>
                    <p>{{translate(locale.home)}}</p>
                </sidebar-link>
                <div
                    style="margin: 10px 0 10px 15px; height: 1px; width: calc(100% - 30px);background-color: rgba(180, 180, 180, 0.3);">
                </div>
                <sidebar-link to="/pending_applications">
                    <md-icon>pending</md-icon>
                    <p>{{translate(locale.pending_applications)}}</p>
                </sidebar-link>
                <sidebar-link to="/ongoing_applications">
                    <md-icon>hourglass_top</md-icon>
                    <p>{{translate(locale.ongoing_applications)}}</p>
                </sidebar-link>
                <sidebar-link to="/completed_applications">
                    <md-icon>task</md-icon>
                    <p>{{translate(locale.completed_applications)}}</p>
                </sidebar-link>
                <template v-if="$store.state.authentication.user_role == 'super-admin'">
                    <div
                        style="margin: 10px 0 10px 15px; height: 1px; width: calc(100% - 30px);background-color: rgba(180, 180, 180, 0.3);">
                    </div>
                    <sidebar-link to="/units">
                        <md-icon>dashboard</md-icon>
                        <p>{{translate(locale.manage_unit)}}</p>
                    </sidebar-link>
                    <sidebar-link to="/users">
                        <md-icon>groups</md-icon>
                        <p>{{translate(locale.manage_user)}}</p>
                    </sidebar-link>
                    <sidebar-link to="/flows">
                        <md-icon>account_tree</md-icon>
                        <p>{{translate(locale.manage_flow)}}</p>
                    </sidebar-link>
                </template>
            </side-bar>

            <div class="main-panel" style="padding-top:68px">

                <transition name="fade" mode="out-in">
                    <router-view></router-view>
                </transition>

                <Footer />
            </div>
        </template>

    </div>
</template>

<script>
    import Footer from '../components/Footer.vue'
    import Header from '../components/Header.vue'
    import Checkpoint from './Checkpoint.vue'
    import Login from './Login.vue'
    export default {
        components: { Header, Footer, Checkpoint, Login },
        created() {
            if (String(this.$store.state.authentication.authToken).length < 64 || this.$store.state.authentication.authToken == null) {
                this.$store.state.authentication.checked = true;
                this.$router.push("/");
            } else {
                this.$http.get(this.config.api + "/user/authenticate").then(res => {

                    if (res.body.status == 'success') {
                        this.$store.state.authentication.loggedIn = true;
                        this.$store.state.authentication.user_hash = res.body.data.user_hash;
                        this.$store.state.authentication.user_name = res.body.data.user_name;
                        this.$store.state.authentication.user_unit_name = res.body.data.user_unit_name;
                        this.$store.state.authentication.user_role = res.body.data.user_role;
                        this.$store.state.authentication.checked = true;
                    }
                })
            }
        },
    }
</script>

<style>
    .fade-enter-active,
    .fade-leave-active {
        transition: opacity .1s
    }

    .fade-enter,
    .fade-leave-to {
        opacity: 0
    }
</style>


// WEBPACK FOOTER //
// src/pages/Layout.vue